module.exports = __webpack_public_path__ + "static/media/veehaari.a9511863.png";